import { render } from "./notificationAlert.vue?vue&type=template&id=a361ac38"
import script from "./notificationAlert.vue?vue&type=script&lang=js"
export * from "./notificationAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__